const { TitleContainer } = require('./container/titleContainer');

export default TitleContainer;